const SYMBOLS = {
    hash: "#",
    asterisk: "*",
    space: " ",
}

const lANGUAGES = {
    spanish: "es",
}

const LEGALDISCLAIMER = {
    configType: "GLOBAL",
}
const UNITS = { TONS: "TONS", LBS: "LBS", BBLMT: "BBL MT" }

const getUserSelectedLanguage = () => {
    const userLanguage = navigator.language || navigator.userLanguage
    const normalizedLanguage = (userLanguage || "").toLowerCase()
    let selectedLanguage = ""
    switch (true) {
        case normalizedLanguage.startsWith("fr"):
            selectedLanguage = "french"
            break
        case normalizedLanguage.startsWith("es"):
            selectedLanguage = "spanish"
            break
        default:
            selectedLanguage = "english"
            break
    }
    return selectedLanguage
}

export { SYMBOLS, lANGUAGES, LEGALDISCLAIMER, getUserSelectedLanguage, UNITS }
